/**
 * ローディング
 */
/*
window.addEventListener('pageshow', function() {
  var wrapper    = $('#wrapper'),
      loader     = $('#js-loader');

  loader.delay(200).fadeOut(300);
});
*/

$(function() {

  'use strict';

  var _this,
      _window = $(window);

  /*
  $(function() {
    var wrapper    = $('#wrapper'),
        loader     = $('#js-loader');

    setTimeout(function() {
      loader.delay(200).fadeOut(300);
    }, 8000);
  });
  */

  /**
   * スムーススクロール
   */
  $(function() {
    var header  = $('#header'),
        headerH = $('#header').height();

    $('a[href^="#"]').on('click', function() {
      _this = $(this);

      if(!_this.hasClass('is-no-smooth')) {
        var href     = _this.attr('href'),
            target   = $(href == '#' || href == '' ? 'html' : href),
            position = target.offset().top - headerH;

        $('html, body').animate({
          scrollTop: position
        }, 1200, 'easeOutExpo');

        return false;
      }
    });

    $(window).on('load', function() {
      var url = $(location).attr('href');

      if(url.indexOf('&id=') != -1) {
        var id = url.split('&id=');
        var target = $('#' + id[id.length - 1]);

        if(target.length) {
          var position = target.offset().top - headerH;

          $('html, body').animate({
            scrollTop: position
          }, 1200, 'easeOutExpo');
        }
      }
    });
  });

  /**
   * Android
   */
  $(function() {
    var ua       = navigator.userAgent;
    var copymark = $('#footer .copyright small .copymark');

    if(ua.indexOf('Android') > 0) {
      copymark.addClass('js-copymark-android');
    } else {
      copymark.removeClass('js-copymark-android');
    }
  });

  /**
   * レスポンシブ 画像
   */
  $(function() {
    var responsiveImages = $('.js-devices-switch-image'),
        windowWidth      = $(window).width();

    responsiveImages.each(function() {
      _this = $(this);

      if(windowWidth <= 768) {
        _this.attr('src', _this.attr('src').replace('_pc', '_sp'));
      } else {
        _this.attr('src', _this.attr('src').replace('_sp', '_pc'));
      }
    });

    _window.on('resize', function() {
      windowWidth = $(window).width();

      responsiveImages.each(function() {
        _this = $(this);

        if(windowWidth <= 768) {
          _this.attr('src', _this.attr('src').replace('_pc', '_sp'));
        } else {
          _this.attr('src', _this.attr('src').replace('_sp', '_pc'));
        }
      });
    });
  });

  /**
   * グロナビ
   */
  $(function() {
    var gnav    = $('#header .gnav, #header .gnav__overlay'),
        trigger = $('#js-drawer-trigger, #header .gnav__overlay');

    // var flag    = false;

    trigger.on('click', function() {
      trigger.toggleClass('is-active');
      gnav.toggleClass('is-open');
      $('body').toggleClass('hidden');

      /*
      if(!flag) {
        // スクロール禁止（iOS）
        document.addEventListener('touchmove.noScroll', function(e) {
          e.preventDefault();
        }, {passive: false});
      } else {
        // スクロール復活（iOS）
        _window.off('.noScroll');
      }
      */
    });

    _window.on('resize', function() {
      if(_window.width() >= 1024) {
        if(trigger.hasClass('is-active')) {
          trigger.removeClass('is-active');
          gnav.removeClass('is-open');
          $('body').toggleClass('hidden');
        }
      }
    });

    _window.on('load', function() {
      var list = $('.gnav__list');

      list.mCustomScrollbar({
        theme: 'minimal'
      });
    });
  });

});
